/** 네 앱이 공유하는 최소 UI 조각. 스타일은 각 앱의 CSS 클래스에 맡긴다. */

import type { ReactNode } from 'react';

export function AppShell({
  title,
  right,
  children,
  footer,
}: {
  title: string;
  right?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="shell">
      <header className="shell__head">
        <h1>{title}</h1>
        {right}
      </header>
      <main className="shell__body">{children}</main>
      {footer && <footer className="shell__foot">{footer}</footer>}
    </div>
  );
}

export function Toolbar({ children }: { children: ReactNode }) {
  return <div className="toolbar">{children}</div>;
}

export function Centered({ children }: { children: ReactNode }) {
  return <div className="centered">{children}</div>;
}

export function Spinner({ label = '불러오는 중…' }: { label?: string }) {
  return (
    <p className="spinner" role="status" aria-live="polite">
      {label}
    </p>
  );
}

export function ErrorBox({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="errorbox" role="alert">
      <p>{message}</p>
      {onRetry && (
        <button type="button" onClick={onRetry}>
          다시 시도
        </button>
      )}
    </div>
  );
}

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="field">
      <span className="field__label">{label}</span>
      <span className="field__value">{children}</span>
    </div>
  );
}
